export enum Command {
  BEANTRAGEN = 'Beantragen',
  ANGEBOT = 'CreateAngebot',
  SPEICHERN = 'SpeichereAntrag',
  SPEICHERN_SB_SHELL_UI = 'SpeichereAntragSBShellUI',
  ELEKTRONISCH_UNTERSCHREIBEN = 'ElektronischUnterschreiben'
}
